import RejectRewardsAllForm from './RejectRewardsAllForm';

export default RejectRewardsAllForm;
